import { useEffect } from 'react';
import { getUri } from 'services/generic';
import useCart from './useCart';
import { useCustomer } from './useCustomer';

const useCartPageStatus = (status: number): void => {
  const { cart } = useCart();
  const { isLogged, isValidating } = useCustomer();

  useEffect(() => {
    if (
      (cart && cart.status < status) ||
      (null !== isLogged && isLogged === false && !isValidating)
    ) {
      window.location.href = getUri('/checkout/cart');
    }
  }, [cart, isLogged]);
};

export default useCartPageStatus;
